<template>
    <div class="messageAlert">
        <SVGIcon :icon-name="message.icon" class="messageAlert__icon" />
        <div class="messageAlert__info">
            <p class="h4">{{ message.title }}</p>
            <span>{{ message.info }}</span>
        </div>
    </div>
</template>

<script>
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'

export default {
    name: 'MessageAlert',

    components: {
        SVGIcon,
    },

    props: {
        message: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="stylus">
.messageAlert {
    background: $cs-slate-050;
    border-radius: $cs-border-radius;
    padding: $cs-spaces.onehalf;

    @media $display-breakpoints.md-and-up {
        display: flex;
    }

    &__icon {
        color: $cs-primary;
        flex:  0 0 auto;
        height: 32px;
        margin: 0 0 $cs-spaces.half;
        width: 32px;

        @media $display-breakpoints.md-and-up {
            margin: 0 $cs-space 0 0;
        }
    }

    .h4 {
        margin: 0 0 $cs-space;

        @media $display-breakpoints.md-and-up {
            margin: 0 0 $cs-spaces.half;
        }
    }
}
</style>
